import Vue from 'vue'
import axios from '../../axios'
export var assess = {
  state: {
    question: {}
  },
  mutations: {
    ASSESS_SET_QUESTION (state, payload) {
      state.question = payload;
    }
  },
  actions: {
    ASSESS_CHECK_KEY ({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.get('/public_auth', {
          params: payload
        }).then((res) => {
          if ( res.status === 200 ){
            resolve()
          } else {
            reject();
          }
        }).catch((err) => {
          reject(err);
        })
      })

    },
    ASSESS_FETCH_QUESTION ({commit}, payload){
      return new Promise((resolve, reject) => {
        commit('ASSESS_SET_QUESTION', payload);
        resolve();
      })

    }
  },
  getters: {
    ASSESS_GET_QUESTION (state) {
      return state.question
    }
  }
};


